module.exports = "<div class=\"modal-content\">\n  <div class=\"modal-header text-center\">\n    <h4 class=\"modal-title\">Salir del Sistema</h4>\n  </div>\n  <div class=\"modal-body\">\n    ¿Desea salir del sistema?\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" (click)=\"closeModal()\">Cancelar</button>\n    <button class=\"btn btn-success\" (click)=\"logoutModal()\">Aceptar</button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalLogout/modalLogout.html
// module id = ../../../../../src/app/theme/components/modals/components/modalLogout/modalLogout.html
// module chunks = 11